import moment from 'moment';
import * as React from 'react';

import { TimePicker } from './TimePicker';

/**
 * A time-of-day field that is picked, not typed (CP-8384).
 *
 * Replaces `<TextField type="time">`. Chrome renders that input as "--:-- --"
 * and reports '' until every segment, AM/PM included, is filled, so a
 * half-typed time saved as null with no warning. This is the picker from the
 * trip Users toolbar (Dep. from / Dep. to): clicking anywhere on the field
 * opens the hour / minute / AM-PM columns, and every pick is a complete time.
 *
 * `value` and `onChange` speak the plain strings the forms already hold:
 * 'HH:mm' (a backend 'HH:mm:ss' reads fine), or '' for no time.
 */
export const toPickerValue = (value) => {
    if (!value) return null;
    const parsed = moment(value, ['HH:mm:ss', 'HH:mm'], true);
    return parsed.isValid() ? parsed : null;
};

export const fromPickerValue = (value) => (value && moment(value).isValid() ? moment(value).format('HH:mm') : '');

const TimeOfDayPicker = ({ label, value, onChange, clearable = true, textFieldProps, sx, ...rest }) => {
    const [open, setOpen] = React.useState(false);

    return (
        <TimePicker
            {...rest}
            label={label}
            value={toPickerValue(value)}
            onChange={(next) => onChange(fromPickerValue(next))}
            ampm
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            sx={sx}
            slotProps={{
                field: { readOnly: true },
                textField: {
                    size: 'small',
                    variant: 'filled',
                    fullWidth: true,
                    InputLabelProps: { shrink: true },
                    onClick: () => setOpen(true),
                    ...textFieldProps,
                },
                actionBar: { actions: clearable ? ['clear'] : [] },
            }}
        />
    );
};

export default TimeOfDayPicker;
